import { EventDateStatusEnum } from "@shared/enums/event-date-status.enum";

export class EventDateUpdateMultipleRequestModel {

    constructor(eventId: number, dates: DateModel[] = []) {
        this.eventId = eventId;
        this.dates = dates;
    }

    eventId!: number;
    dates!: DateModel[];
}

export class DateModel {
    id!: number;
    status!: EventDateStatusEnum;
    start?: Date;
    startTime?: Date;
    end?: Date;
    isPrivate?: boolean;
    venueName?: string;
    venueCity?: string;
    capacity?: number;
}
